<template>
  <div class="job-linkedin-search">
    <p>{{ $t('campaign.search-linkedin.description') }}</p>
    <b-btn class="mr-2 mb-3" :href="linkedInSearchURL || defaultLinkedInSearchURL" @click="$emit('trackedLiBrowseEvent')" target="_blank"
      variant="linkedin"><font-awesome-icon class="mr-2" :icon="['fab', 'linkedin']"/> {{ $t('campaign.search-linkedin.button') }}</b-btn>
    <p>{{ $t('campaign.search-linkedin.instructions') }}</p>
    <p class="m-0">{{ $t('campaign.search-linkedin.code') }}</p>
    <b-btn class="d-block text-truncate text-left px-0" disabled :href="shareUrl" variant="transparent">{{ shareUrl }}</b-btn>
    <b-btn class="text-dark" v-clipboard:copy="shareUrl" v-clipboard:success="() => $emit('trackShareEvent', { channel: 'url' })" variant="light">
      {{ $t('share.ctas.copy-link') }} <font-awesome-icon icon="link"/>
    </b-btn>
    <p class="m-0 mt-4">{{ $t('share.sample-message.unsure-suggestion') }}</p>
    <blockquote class="share-example lead text-muted my-2">
      {{ exampleShareText }}
      <a class="d-block text-muted text-decoration-none text-truncate pointer-events-none" :href="shareUrl" target="_blank">{{ shareUrl }}</a>
    </blockquote>
    <div class="d-flex flex-row" :class="{ 'justify-content-start': !centered, 'justify-content-center': centered }">
      <a href="#" v-clipboard:success="() => $emit('trackShareEvent', { channel: 'url' })" v-clipboard:copy="`${exampleShareText}\n${shareUrl}`">
        <small>{{ $t('share.ctas.copy-sample-message') }}</small>
      </a>
      <!-- <span class="flex-fill"/> -->
      <!-- <a href="#"><small>Refresh</small></a> -->
    </div>
  </div>
</template>

<script>
import qs from 'querystring';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    jobID: {
      type: String,
      required: true,
    },
    jobTitle: {
      type: String,
      default: null,
    },
    linkedInSearchURL: {
      type: String,
      default: null,
    },
    shareUrl: {
      type: String,
      required: true,
    },
    previewText: {
      type: String,
      default: null
    },
    previewArgs: {
      type: Object,
      default: () => null,
    },
    centered: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isNativeApp', 'isAssurant', 'isHelloFresh' ]),
    exampleShareText() {
      let text = this.previewText;

      if (this.isAssurant && this.user && this.user.locale === 'fr') {
        text = 'Assurant recrute ! Nous recherchons un(e) {jobTitle} pour rejoindre notre équipe. Consultez l’annonce et postulez maintenant !';
      }

      if (this.isHelloFresh && this.user && this.user.locale === 'de') {
        text = 'Hast du Lust mit mir bei HelloFresh als {jobTitle} zu arbeiten? Jetzt bewerben!';
      }

      return typeof text === 'string'
        ? text.trim().replace(/\{([\w\d_]+)\}/g, (value, key) => {
          if (this.previewArgs && this.previewArgs[key]) {
            return this.previewArgs[key];
          } else {
            return value;
          }
        })
        : null;
    },
    defaultLinkedInSearchURL() {
      if (this.jobTitle) {
        return `https://www.linkedin.com/search/results/people?${qs.stringify({
          keywords: this.jobTitle,
          network: JSON.stringify([ 'F' ]),
        })}`;
      } else {
        return null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/LinkedInSearch.vue